import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PropertyPage from "@/pages/property/_id/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyDetail',
  setup(__props) {

// TODO: Implement new property detail style, instead of the existing PropertyPage

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PropertyPage))
}
}

})